import { Component, Ref } from 'vue';

export class MyAccountPageTabManager {
  private readonly tabComponents: Map<string, Component>;
  private readonly validations: Map<string, Ref<any> | undefined>;

  constructor(options: MyAccountPageTabManagerOption[]) {
    this.tabComponents = new Map<string, Component>();
    this.validations = new Map<string, Ref<any>>();

    for (const opt of options) {
      this.tabComponents.set(opt.tabName, opt.component);
      this.validations.set(opt.tabName, opt.validationRules);
    }
  }

  public resolveComponent(tabName: string) {
    return this.tabComponents.get(tabName);
  }

  public resolveValidationRules(tabName: string) {
    return this.validations.get(tabName)?.value;
  }
}

export interface MyAccountPageTabManagerOption {
  tabName: string;
  component: Component;
  validationRules?: Ref<any>;
}